import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-054a96b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bigbox" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"15px","width":"100%"} }, null, -1))
const _hoisted_4 = { class: "pickBox" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "redtext" }, "请输入10字以内的中文汉字或英文字母", -1))
const _hoisted_6 = { class: "pickBox" }
const _hoisted_7 = { class: "redtext" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 如无角色数据请在角色权限管理中先创建 ")
const _hoisted_9 = { class: "pickBox" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "redtext" }, "仅支持输入11位手机号码", -1))
const _hoisted_11 = { class: "pickBox" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "redtext" }, "仅支持输入6-16位字母或数字", -1))
const _hoisted_13 = { class: "pickBox" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "redtext" }, "密码长度为6-14位，必须为数字和字母组合", -1))
const _hoisted_15 = { class: "pickBox" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("男")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("女")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("保密")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "redtext",
    style: {"margin":"0"}
  }, "最多支持上传1张图片，大小不超过500K，格式为JPG或PNG")
], -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("提交")

import { defineComponent, reactive, ref } from "vue";
import type { UploadProps, FormRules, FormInstance } from "element-plus";
import { roleListSimple, addSysAdmin, sysAdminInfo, editSysAdmin, addrole } from "../../../../api/SysAdmin";
import { useRoute, useRouter } from "vue-router";
import md5 from "js-md5";
import { Plus } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const checkPhone = (rule: any, value: string, callback: any) => {
  let reg = /^1[345789]\d{9}$/;
  if (!reg.test(value)) {
    callback(new Error("请输入正确的手机号码"));
  } else {
    callback();
  }
};
const btnLoading = ref(false);
const route = useRoute();
const { userId } = route.query;
const router = useRouter();
const img = ref("/compontsimg/icon_plus.png");
const title = ref("添加职员");
const form = ref<Req.addSysAdmin>({
  userName: "",
  roleName: "",
  roleNo: "",
  phone: "",
  account: "",
  password: "",
  entryTime: "",
  userSex: "",
  headPic: "",
});
const getRoleListSimple = () => {
  roleListSimple().then((res) => {
    if (res.code === 1) {
      console.log(res);
      role.value = res.data;
    }
  });
};
getRoleListSimple();
const getSysAdminInfo = () => {
  if (userId) {
    sysAdminInfo(userId as string).then((res) => {
      if (res.code === 1) {
        res.data.password = "";
        form.value = res.data;
      }
    });
  }
};
getSysAdminInfo();
const role = ref();
const rules = reactive<FormRules>({
  userName: [{ required: true, message: "请输入职员姓名", trigger: "blur" }],
  roleNo: [{ required: true, message: "请选择职员角色", trigger: "change" }],
  phone: [
    { required: true, message: "请输入联系电话", trigger: "blur" },
    { type: "number", validator: checkPhone, trigger: "blur" },
  ],
  account: [
    { required: true, message: "请输入登录账号", trigger: "blur" },
    {
      pattern: /[0-9A-Za-z]{6,14}$/gi,
      message: "仅支持输入6-16位字母或数字",
      trigger: "blur",
    },
  ],
  password: [
    { required: true, message: "请输入登录密码", trigger: "blur" },
    {
      pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,14}$/gi,
      message: "密码长度为6-14位，必须为数字和字母组合",
      trigger: "blur",
    },
  ],
  entryTime: [{ required: true, message: "请选择入职时间", trigger: "change" }],
  userSex: [{ required: true, message: "请选择性别", trigger: "change" }],
  headPic: [{ required: true, message: "请上传职员头像", trigger: "change" }],
});

const ruleFormRef = ref<FormInstance>();

const changeImg = (val: any) => {
  console.log(val, "上传图片");
  form.value.headPic = val.fileUrl;
};
const delectImg = (val: string) => {
  form.value.headPic = val;
};
const submitForm = async (formEl: FormInstance | undefined) => {
  console.log(formEl);

  if (!formEl) return;
  await formEl.validate((valid: any, fields: any) => {
    if (valid) {
      role.value.forEach((item: any) => {
        if (item.roleNo == form.value.roleNo) {
          form.value.roleName = item.roleName;
        }
      });
      setSysAdmin();
    } else {
      console.log("error submit!", fields);
    }
  });
};
const setSysAdmin = () => {
  btnLoading.value = true;
  if (userId) {
    editSysAdmin(form.value)
      .then((res) => {
        if (res.code === 1) {
          ElMessage({
            message: (res.msg as string) || "操作成功",
            type: "success",
          });
          FromBack();
        }
        btnLoading.value = false;
      })
      .catch((err) => {
        btnLoading.value = false;
      });
  } else {
    form.value.password = md5(form.value.password).toUpperCase();
    addSysAdmin(form.value)
      .then((res) => {
        if (res.code === 1) {
          ElMessage({
            message: (res.msg as string) || "操作成功",
            type: "success",
          });
          FromBack();
        }
        btnLoading.value = false;
      })
      .catch((err) => {
        btnLoading.value = false;
      });
  }
};
const FromBack = () => {
  router.go(-1);
};

return (_ctx: any,_cache: any) => {
  const _component_Globalcontentarea = _resolveComponent("Globalcontentarea")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_MyUpload = _resolveComponent("MyUpload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Globalcontentarea, {
        title: title.value,
        img: img.value
      }, null, 8, ["title", "img"]),
      _hoisted_3,
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: form.value,
        "label-width": "120px",
        rules: rules
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "职员姓名",
            prop: "userName"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_input, {
                  maxlength: "10",
                  class: "myinput",
                  clearable: "",
                  modelValue: form.value.userName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.userName) = $event)),
                  placeholder: "请输入职员姓名"
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "职员角色",
            prop: "roleNo"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_select, {
                  modelValue: form.value.roleNo,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.roleNo) = $event)),
                  placeholder: "请选择职员角色"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(role.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.roleName,
                        value: item.roleNo,
                        key: item.roleNo
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("span", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("span", {
                  style: {"color":"#0981ff","text-decoration":"underline","cursor":"pointer"},
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push(`/Staffmanagement/Role/addrole`)))
                }, " 添加角色 ")
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "联系电话",
            prop: "phone"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_input, {
                  modelValue: form.value.phone,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.phone) = $event)),
                  modelModifiers: { trim: true },
                  clearable: "",
                  onkeyup: "value=value.replace(^[1]+[3,8]+\\d{9}$,'')",
                  placeholder: "请输入手机号码"
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "登录账号",
            prop: "account"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_input, {
                  modelValue: form.value.account,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.account) = $event)),
                  modelModifiers: { trim: true },
                  clearable: "",
                  placeholder: "请输入登录账号"
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_12
            ]),
            _: 1
          }),
          (!_unref(userId))
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "登录密码",
                prop: "password"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_el_input, {
                      type: "password",
                      clearable: "",
                      modelValue: form.value.password,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.password) = $event)),
                      onkeyup: "this.value = this.value.replace(,'')",
                      placeholder: "请输入密码"
                    }, null, 8, ["modelValue"])
                  ]),
                  _hoisted_14
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            prop: "entryTime",
            label: "入职时间"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_el_date_picker, {
                  modelValue: form.value.entryTime,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.entryTime) = $event)),
                  format: "YYYY/MM/DD",
                  "value-format": "x",
                  type: "date",
                  placeholder: "请选择入职时间",
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: '性' + '       ' + '别',
            prop: "userSex"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: form.value.userSex,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.userSex) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, { label: 0 }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: 1 }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: 2 }, {
                    default: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "职员头像",
            prop: "headPic"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_MyUpload, {
                  modelValue: form.value.headPic,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.headPic) = $event)),
                  imageUrl: form.value.headPic,
                  tipText: "",
                  onChangeImg: changeImg,
                  uploadSize: 500,
                  onDelectImg: delectImg
                }, null, 8, ["modelValue", "imageUrl"]),
                _hoisted_19
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { "label-width": "37px" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                style: {"width":"80px"},
                onClick: FromBack,
                class: "cancelBtn"
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                style: {"width":"80px"},
                type: "primary",
                loading: btnLoading.value,
                onClick: _cache[9] || (_cache[9] = ($event: any) => (submitForm(ruleFormRef.value)))
              }, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ]))
}
}

})